//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import HowExtraWorksItem from './HowExtraWorksItem';
import howExtraNumberOne from '~/assets/images/1-Circle.png';
import howExtraNumberTwo from '~/assets/images/2-Circle.png';
import howExtraNumberThree from '~/assets/images/3-Circle.png';
import howExtraImageOne from '~/assets/images/howExtraBox-1.png';
import howExtraImageTwo from '~/assets/images/howExtraBox-2.png';
import howExtraImageThree from '~/assets/images/howExtraBox-3.png';
export default {
  name: 'HowExtraWorks',
  components: {
    HowExtraWorksItem
  },

  data() {
    return {
      numberImages: [howExtraNumberOne, howExtraNumberTwo, howExtraNumberThree],
      images: [howExtraImageOne, howExtraImageTwo, howExtraImageThree]
    };
  }

};